import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';

export interface WacStartConfig {
    featuredDocumentsEnabled: boolean;
    maxInitialDocuments: number;
    maxTotalDocuments: number;
    startPageNumTemplatesToShow: number;
    visioMoreTemplatesUrl: string;
    moreTemplatesRedirectionEnabled: boolean;
    streamCrossLinkUrl: string;
    streamDocumentationUrl: string;
    resources: WacStartResources;
    streamPreviewString: string;
    visioLibraryTileEnabled: boolean;
    visioMoreTemplatesEnabled: boolean;
    consumerExcelStartPageTemplateCollection: string | undefined;
    consumerWordStartPageTemplateCollection: string | undefined;
    consumerPowerPointStartPageTemplateCollection: string | undefined;
}

export interface WacStartResources {
    StartPageCreateDropdownAriaLabel: string;
    StartPageCreateDropdownTooltip: string;
    StartPageCreatePrompt: string;
    StartPageWelcome: string;
}

@Injectable({
    providedIn: 'root'
})
export class WacStartConfigService {
    public readonly config: WacStartConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<WacStartConfig>('wacStartPageConfig') || {
            featuredDocumentsEnabled: false,
            maxInitialDocuments: 0,
            maxTotalDocuments: 0,
            startPageNumTemplatesToShow: 0,
            visioMoreTemplatesUrl: null,
            moreTemplatesRedirectionEnabled: false,
            streamCrossLinkUrl: null,
            streamDocumentationUrl: null,
            resources: null,
            streamPreviewString: 'StreamCrossLinkText',
            visioLibraryTileEnabled: false,
            visioMoreTemplatesEnabled: false,
            consumerExcelStartPageTemplateCollection: '',
            consumerWordStartPageTemplateCollection: '',
            consumerPowerPointStartPageTemplateCollection: ''
        };
    }
}
